import { render, staticRenderFns } from "./MainProduct.vue?vue&type=template&id=57a3d0cd&"
import script from "./MainProduct.vue?vue&type=script&lang=js&"
export * from "./MainProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports